import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs/Observable";

const JsonHeaders = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
};

@Injectable()
export class HttpJsonInterceptor implements HttpInterceptor{
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{
        if(request.method === 'POST' || request.method === 'PUT'){
            request = request.clone({setHeaders: JsonHeaders});
        }
        return next.handle(request);
    }
}


// WEBPACK FOOTER //
// ./src/app/http-json.interceptor.ts